/* eslint-disable max-len */
import { NavLink } from 'react-router-dom';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';

const BASE_URL = `/${routes.TEMPLATES}`;
const title = 'Templates';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getUiTemplatesMenuItems = () => {
    const menu = [
        {
            group: 'Content',
            navItems: [
                {
                    key: 'featureCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/feature-cards`}>
                            Feature cards
                        </NavLink>
                    ),
                    meta: 'action panels feature cards template',
                },
                {
                    key: 'chatAssistant',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/chat-assistant`}>
                            AI Chat assistant
                        </NavLink>
                    ),
                    meta: 'chat assistant ai disclaimer query template',
                },
                {
                    key: 'detailViews',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/detail-views`}>
                            Detail views
                        </NavLink>
                    ),
                    meta: 'details views blocks template',
                },
                {
                    key: 'expandableDetails',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/expandable-details`}>
                            Expandable details
                        </NavLink>
                    ),
                    meta: 'expandable details blocks template',
                },
                {
                    key: 'lists',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/list-blocks`}>
                            List blocks
                        </NavLink>
                    ),
                    meta: 'lists blocks template',
                },
                {
                    key: 'panelVariants',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/panel-variants`}>
                            Panel variants
                        </NavLink>
                    ),
                    meta: 'panel variants blocks template',
                },
                {
                    key: 'optionsPanel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/options-panel`}>
                            Options panel
                        </NavLink>
                    ),
                    meta: 'options panel template',
                },
                {
                    key: 'usageCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/usage-cards`}>
                            Usage cards
                        </NavLink>
                    ),
                    meta: 'usage cards template',
                },
                {
                    key: 'stats',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/stats-blocks`}>
                            Stats blocks
                        </NavLink>
                    ),
                    meta: 'stats summary blocks template',
                },
            ],
        },
        {
            group: 'Forms',
            navItems: [
                {
                    key: 'settingsForm',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/settings-form`}>
                            Settings form
                        </NavLink>
                    ),
                    meta: 'settings forms template',
                },
                {
                    key: 'formToggle',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/form-toggle`}>
                            Form toggle
                        </NavLink>
                    ),
                    meta: 'forms toggle template',
                },
                {
                    key: 'formSummary',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/form-summary`}>
                            Form summary
                        </NavLink>
                    ),
                    meta: 'forms summary template',
                },
            ],
        },
        {
            group: 'Progress',
            navItems: [
                {
                    key: 'loadingProgress',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/loading-progress`}>
                            Loading progress
                        </NavLink>
                    ),
                    meta: 'loading progressbar template',
                },
                {
                    key: 'progressCards',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/progress-cards`}>
                            Progress cards
                        </NavLink>
                    ),
                    meta: 'progress cards template',
                },
                {
                    key: 'progressSuccess',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/progress-success`}>
                            Progress success
                        </NavLink>
                    ),
                    meta: 'progress success template',
                },
            ],
        },
        {
            group: 'Tables',
            navItems: [
                {
                    key: 'commonTable',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/common-table`}>
                            Common table
                        </NavLink>
                    ),
                    meta: 'basic common table template',
                },
                {
                    key: 'tablePanel',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/table-panel`}>
                            Table panel
                        </NavLink>
                    ),
                    meta: 'table expand panel combined tables in ExpandablePanel template',
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const UITemplatesMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
